module.exports = "/assets/data/acd77ca11b7121e84684c31d45cc339e-BT66.data.json";